import { actionCreators } from "./actionCreators";
import { reducer } from "./reducer";

const accountStore = {
    actionCreators,
    reducer
}

export default accountStore;